module.exports = __webpack_public_path__ + "f55d20b9d9d8fbbd58abff8c72c8c4cb.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/images/navigators/ic-anchor-live.svg
// module id = 1494
// module chunks = 3